/**
 * Created by JAVIER on 10/31/2019.
 */
import React from 'react'
import {Tooltip, Icon} from 'antd'
import './smallvideoCss.css'

class SmallVideo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selected: false,
        }
    }

    handleOnClick = () => {
        this.props.onClick(this)
    }

    setHighlight = status => {
        this.setState({
            selected: status,
        })
    }

    handleOnDoubleClick = () => {
        this.props.onDoubleClick(this.props.file)
    }

    handleOnDragStart = e => {
        e.dataTransfer.dropEffect = 'copy'
        e.dataTransfer.setData(
            'data',
            JSON.stringify({id: this.props.file._id, type: 'video'})
        )
    }

    getImageUrl = () => {
        return this.props.shared ? `/api/v1/share/videos/image/small/${this.props.file._id}?token=${this.props.token}`
            : '/api/v1/videos/image/small/' + this.props.file._id;
    }

    render() {
        const comments = this.props.file.comments

        return (
            <Tooltip title={comments}>
                <div
                    className={'video ' + (this.state.selected ? 'video-border' : '')}
                    onClick={this.handleOnClick}
                    onDoubleClick={this.handleOnDoubleClick}
                >
                    <img
                        className="image"
                        src={this.getImageUrl()}
                        draggable="true"
                        onDragStart={this.handleOnDragStart}

                    />
                    <Icon type="play-circle"  className="icon"/>
                </div>
            </Tooltip>
        )
    }
}

export default SmallVideo
